<div class="nav-tree-container" *ngIf="data && roots.length > 0; else noData">

  <!-- Summary stats -->
  <div class="nav-tree-summary">
    <div class="nav-tree-stat">
      <span class="nav-tree-stat-value">{{ totalVisits }}</span>
      <span class="nav-tree-stat-label">Total Events</span>
    </div>
    <div class="nav-tree-stat">
      <span class="nav-tree-stat-value">{{ totalCategories }}</span>
      <span class="nav-tree-stat-label">Categories</span>
    </div>
  </div>

  <!-- Column headers -->
  <div class="nav-tree-header">
    <span class="nav-tree-col-toggle"></span>
    <span class="nav-tree-col-name">Screen / Element</span>
    <span class="nav-tree-col-visits">Visits</span>
    <span class="nav-tree-col-bar">Distribution</span>
  </div>

  <!-- Tree rows -->
  <div class="nav-tree-body">
    <app-nav-node
      *ngFor="let root of roots"
      [node]="root"
      [depth]="0"
      [maxVisits]="maxVisits"
    ></app-nav-node>
  </div>

</div>

<ng-template #noData>
  <div class="nav-tree-empty">
    <strong>No Data Available</strong>
  </div>
</ng-template>
